import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const wimaumaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Wimauma Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Wimauma, FL. Sam\'s Tree Service handles dangerous rural and residential trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_wimauma',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Wimauma',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Wimauma Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we travel to <strong>Wimauma</strong> 
     to handle the tree work that rural and residential properties in this growing 
     South Hillsborough community need. Large lots, new construction near existing 
     tree lines, and the heavy growth that comes with Florida's wet season all 
     create conditions where trees become serious hazards. Our team brings the 
     right equipment and the experience to handle any size job.`,

    `We specialize in <strong>large lot and residential tree removal and trimming</strong> 
     storm cleanup, massive tree takedowns, overgrown canopy clearance near new 
     homes and outbuildings, and debris hauling that leaves your property clean 
     and ready. We handle the complex jobs other companies pass on.`,

    `<strong>Sam's Tree Service</strong> provides dependable, affordable tree care 
     throughout <strong>Wimauma</strong> and the surrounding 
     <strong>South Hillsborough</strong> rural and residential corridor 
     keeping your property protected and your trees managed year round.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Wimauma, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Wimauma = () => <LocationPage config={wimaumaConfig} />;
export default Services_Wimauma;
